/**
 * @file Utils for validation
 * */

import i18n from './../i18n'
import { TranslateResult, Values } from 'vue-i18n'
import _ from 'lodash'
import { stringLength } from './unicodeUtil'
import emoji from 'emoji-regex';

export interface IValidate {
  validate: boolean;
  message: string | TranslateResult;
}

// TODO-abtest 重新优化一下这个函数
const validateFunCreator = (
  func: Function,
  message: string,
  ...args: unknown[]
): Function => {
  return async (str: '', ...args2: unknown[]): Promise<IValidate> => {
    const validate = await func(str.toString().trim(), ...args, ...args2)

    // 税号国家码错误需要具体提示，返回的validate是对象
    if (_.isObject(validate)) {
      return validate as IValidate
    } else {
      let msg = i18n.t(message, args[0] as Values)

      if (validate) {
        msg = ''
      }
      return {
        validate,
        message: msg
      }
    }
  }
}

/**
 * 非空校验
 */
const isRequired = (str: string | number): boolean => {
  return str.toString().trim().length !== 0
}
export const validateRequired = validateFunCreator(
  isRequired,
  'common_input_require_required'
)

/**
 * 数字校验
 */
const isAllNum = (str: string | number): boolean => {
  return /^[0-9]+$/.test(str.toString())
}
const specificNumber = (str: string, len: ValidateLen): boolean => {
  const { length } = len
  return isAllNum(str) && str.length === length
}
export const validateAllNum = [
  validateFunCreator(isAllNum, 'common_input_require_number')
]
export const validateNumLen = (length: number): Function[] => {
  return [
    validateFunCreator(specificNumber, 'common_input_require_specify_number', {
      length
    })
  ]
}

interface ValidateLen {
  length: number;
}

interface VatRetVal {
  valid: boolean;
  detail: string;
}

export const isNull = (obj: any): boolean =>
  Object.prototype.toString.call(obj) === '[object Null]'
export const isUndefinded = (obj: any): boolean =>
  Object.prototype.toString.call(obj) === '[object Undefinded]'

export const protocolExpr = /^((?:https?|ftp):\/\/)/i

export const checkProtocol = (str: string): boolean => {
  return protocolExpr.test(str)
}

export const checkNameLength = (str: string): boolean =>
  !!str && stringLength(str.trim()) <= 512

export const containsNoEmojis = (str: string): boolean => !emoji().test(str);

export const lengthLessThanEqualTo100 = (str: string): boolean =>
  str.length <= 100

export const lengthNotEmpty = (str: string): boolean =>
  str.length > 0

export const validatePromoteLink = [
  validateFunCreator(isRequired, 'module_fastcreation_popup_promotelink_hint0'),
  validateFunCreator(
    checkProtocol,
    'module_fastcreation_popup_promotelink_hint1'
  )
]

export const checkAdName = [
  validateFunCreator(isRequired, 'common_rename_hint'),
  validateFunCreator(checkNameLength, 'ad_name_max_hint')
]

export const checkAdGroupName = [
  validateFunCreator(isRequired, 'common_rename_hint'),
  validateFunCreator(checkNameLength, 'adgroup_name_max_hint')
]

export const checkCampaignName = [
  validateFunCreator(isRequired, 'common_rename_hint'),
  validateFunCreator(checkNameLength, 'campaign_name_max_hint')
]

export const checkAdText = [
  validateFunCreator(isRequired, 'module_fastcreation_creative_text_tooshort'),
  validateFunCreator(containsNoEmojis, 'module_fastcreation_creative_text_emoji'),
  validateFunCreator(lengthLessThanEqualTo100, 'module_fastcreation_creative_text_toolong'),
]

export const checkPromotionUrl = (text: string): string => {
  let newText = ''
  // 将协议头里的大写字母转为小写
  if (protocolExpr.test(text)) {
    newText = text.replace(protocolExpr, RegExp.$1.toLowerCase())
  } else if (!text.startsWith('http')) {
    // 自动补充协议头
    newText = `http://${text}`
  }
  return newText
}

export const validatorsFun = (
  rule: Array<any>,
  value: string
): Promise<IValidate> => {
  return new Promise((resolve) => {
    let validate = true,
      msg = ''
    for (let i = 0; i < rule?.length; i++) {
      const { message, required, len, pattern, realPattern } = rule[i]
      const isNull = !value || value.toString() === '-1'
      if (isNull && required) {
        msg = message
        validate = false
        break
      }
      if (!isNull && len && value?.length !== len) {
        msg = message
        validate = false
        break
      }
      if (
        !isNull && ((
          realPattern &&
          !realPattern.test(value)
        ) || (
          pattern &&
          !new RegExp(eval(pattern?.trim())).test(value)
        ))
      ) {
        msg = message
        validate = false
        break
      }
    }
    resolve({
      validate,
      message: msg
    })
  })
}
